/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopyUserPermissionsRequest
 */
export interface CopyUserPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CopyUserPermissionsRequest
     */
    sourceUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopyUserPermissionsRequest
     */
    targetUserId?: string | null;
}

export function CopyUserPermissionsRequestFromJSON(json: any): CopyUserPermissionsRequest {
    return CopyUserPermissionsRequestFromJSONTyped(json, false);
}

export function CopyUserPermissionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyUserPermissionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceUserId': !exists(json, 'sourceUserId') ? undefined : json['sourceUserId'],
        'targetUserId': !exists(json, 'targetUserId') ? undefined : json['targetUserId'],
    };
}

export function CopyUserPermissionsRequestToJSON(value?: CopyUserPermissionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sourceUserId': value.sourceUserId,
        'targetUserId': value.targetUserId,
    };
}


